import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '../styles/vendors.css';
import '../styles/styles.css';
import '../styles/tailwind.css';

// Get root element
const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
    <App />
);
